Billy.Country.reopen({
    iconUrl: function() {
        return Billy.flagIcon(this.get('icon'))
    }.property('icon')
})
